export const INVALID_NUMBER_OF_ORDERS = 'INVALID_NUMBER_OF_ORDERS';
export const GENERAL_ERROR = 'GENERAL_ERROR';
export const ORDERS_INCLUDED_IN_OTHER_BATCH = 'ORDERS_INCLUDED_IN_OTHER_BATCH';
